import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useLocalization } from '../../hooks/useLocalization';

import { FETCH_CLIENT_REPORT_NAME } from './clientReportBreadcrumb.query';

export function ClientReportBreadcrumb() {
  const { translateBackendString } = useLocalization();
  const { t } = useTranslation('clientReportTemplate');
  const { clientReportTemplateId } = useParams();

  const { data } = useQuery(FETCH_CLIENT_REPORT_NAME, {
    variables: { clientReportTemplateId },
  });

  const clientReportName =
    data?.fetchClientReportTemplate?.clientReportTemplate?.translatedName;

  return clientReportName
    ? translateBackendString(clientReportName)
    : t('clientReport');
}
